/* eslint-disable react/prop-types */
/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import RenderToolTip from "../../../../component/tooltip/RenderToolTip";
import TextInput2 from "../../../../component/input/TextInput2";
import SelectInput2 from "../../../../component/input/SelectInput2";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../../../constant/helper/helper";
import SpinnerButton from "../../../../component/spinner/SpinnerButton";
import Button from "../../../../component/button/Button";

const TopInput = ({
  values,
  loading,
  onSubmit,
  onChange,
  currentUser,
  allLocations
}) => {
  const toolTipData = [
    {
      id: "date",
      text: "Select To date."
    },
    {
      id: "locationName",
      text: "Select Location to Get the Users Attendance."
    }
  ];

  return (
    <div className="row">
      <RenderToolTip toolTipData={toolTipData} />
      <div className="col-3">
        <TextInput2
          data-tip
          type="date"
          name="date"
          onChange={onChange}
          value={values.date}
          data-for="date"
          icon="mdi mdi-calendar-check"
          placeholder="Select Date"
        />
      </div>

      <div className="col-3">
        <SelectInput2
          data-tip
          isLabeled={true}
          name="locationId"
          onChange={onChange}
          data-for="locationName"
          label="Select Location"
          value={values.locationId}
          placeholder="Select Location"
          icon="mdi mdi-map-marker-radius"
        >
          {isSuperAdmin(currentUser)
            ? renderLocationFunction(allLocations)
            : renderAccessLocation2(
                locationRender(currentUser, false)
              )}
        </SelectInput2>
      </div>
      {loading === true ? (
        <div className="col-sm-2">
          <SpinnerButton />
        </div>
      ) : (
        <div className="col-2">
          <div className="form-group">
            <Button
              type="button"
              onClick={onSubmit}
              title="GET"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
        </div>
      )}
    </div>
  );
};

TopInput.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TopInput;
